export function visibleWarnings(warnings: readonly string[]): readonly string[] {
  return warnings.filter((warning) => warning !== 'No active warnings');
}
